<template>
    <v-card class="ma-0 pa-3 wrapper">
        <v-container class="pa-0 d-flex align-center justify-space-between gap-8">
            <div class="d-flex align-center gap-2">
                <v-chip
                    label
                    class="product-label"
                >
                    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path opacity="0.5" d="M13.332 21.8012C16.458 21.1752 20.5 18.9262 20.5 13.1112C20.5 7.82017 16.627 4.29617 13.842 2.67717C13.223 2.31717 12.5 2.79018 12.5 3.50517V5.33318C12.5 6.77518 11.894 9.40718 10.21 10.5022C9.35 11.0612 8.42 10.2242 8.316 9.20418L8.23 8.36618C8.13 7.39218 7.138 6.80118 6.36 7.39517C4.961 8.46018 3.5 10.3302 3.5 13.1102C3.5 20.2212 8.789 22.0002 11.433 22.0002C11.5877 22.0002 11.749 21.9952 11.917 21.9852C12.363 21.9292 11.917 22.0842 13.332 21.8002" fill="#00664D"/>
                    <path d="M8.5 18.4444C8.5 21.0644 10.611 21.8744 11.917 21.9864C12.363 21.9304 11.917 22.0854 13.332 21.8014C14.371 21.4344 15.5 20.4924 15.5 18.4444C15.5 17.1474 14.681 16.3464 14.04 15.9714C13.844 15.8564 13.616 16.0014 13.599 16.2274C13.543 16.9454 12.853 17.5174 12.384 16.9714C11.969 16.4894 11.794 15.7844 11.794 15.3334V14.7434C11.794 14.3894 11.437 14.1534 11.131 14.3354C9.995 15.0084 8.5 16.3944 8.5 18.4444Z" fill="#00664D"/>
                    </svg>
                </v-chip>
                <v-card-text class="pa-0 text-body-2">{{ $t('popular-product') }}</v-card-text>
            </div>
            <!-- <v-select
                :items="items"
                label="امروز"
                dense
                append-icon="mdi-chevron-down"
                class="mt-0"
                style="width: 0;"
            >
            </v-select> -->
        </v-container>
        <v-card-text class="pa-0 text-caption white--text mt-4 mb-6" style="width: 150px;">
          {{ $t('products that make up more than 50% of your sales.') }}
        </v-card-text>
        <div v-if="$store.getters.getpermission && $store.getters.getpermission.includes('overview')">
          <v-container
            v-if="popularProduct != null && popularProduct != undefined"
            class="pa-0 d-flex align-center gap-2"
          >
              <v-card-text
              class="pa-0 text-body-1"
              >
              {{ popularProduct }}
              </v-card-text>
              <v-card-text class="pa-0 text-caption white--text">{{ $t('product') }}</v-card-text>
          </v-container>
          <v-container
            v-if="popularProduct == null && popularProduct == undefined"
            class="pa-0"
          >
            <v-card-text class="pa-0 text-caption">
              {{ $t('there is no enough information for showing.') }}
            </v-card-text>
          </v-container>
        </div>
        <div v-else>
          <v-card-text class="pa-0 text-caption">
            {{ $t("you don't have access to this information") }}
          </v-card-text>
        </div>
    </v-card>
</template>

<script>
export default {
  data () {
    return {
      popularProduct: null
    }
  },
  methods: {
    fetchList () {
      var app = this
      app.$axios.get(this.$endpoint + 'productsreport', {
        params: {
          report: 'overview',
          dateType: 'year',
          threshold: 0.1
        }
      })
        .then(r => {
          this.popularProduct = r.data.sellProductsCount
        })
        .catch(e => {
          console.error('Error:', e)
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  mounted () {
    this.fetchList()
  }
}
</script>

<style scoped>
.wrapper {
    background-color: #00664D;
    padding: 10px;
    color: #fff;
}
.product-label {
    padding: 0 !important;
    width: 35px;
    height: 33px;
    background: #fff !important;
    display: flex;
    align-items: center;
    justify-content: center;
}
.v-card__text {
    width: auto;
}
::v-deep .v-text-field > .v-input__control > .v-input__slot:before {
    border-color: transparent !important;
}
::v-deep .v-text-field.v-input--dense .v-label {
    top: 0 !important;
}
::v-deep .v-label.v-label {
    font-size: 10px !important;
    color: #fff;
}
::v-deep .v-icon.v-icon {
    color: #fff;
    font-size: 15px;
}
.v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none !important;
}
</style>
